import { isType } from '@mtna/core-ts';
import { Variable } from '@mtna/pojo-consumer-ts';
import { VariableSummary } from '@mtna/variable-service-core-ts';

import { RdsNumericFilter } from '../../../numeric-filter/numeric-filter.model';
import { BaseFilter } from './base-filter.model';
import { RdsNullFilter } from './null-filter.model';

export class FilterByNumber<V extends Variable | VariableSummary> extends BaseFilter<V> {
  constructor(variable: V, public numericFilters: Array<RdsNumericFilter>, nullFilter?: RdsNullFilter) {
    super(variable, nullFilter);
  }
}

export function instanceOfFilterByNumber(something: unknown): something is FilterByNumber<Variable | VariableSummary> {
  return isType<FilterByNumber<Variable | VariableSummary>>(something, 'variable', 'numericFilters');
}
